import rehabApi from '@Apis/rehab.api';
import type { RehabDecisionTreeApi } from '@Types/rehab.types';

export const groupSetKeys = {
	all: ['groupSets'] as const,
	list: () => [...groupSetKeys.all, 'list'] as const,
};

export const allGroupSetsQuery = () => ({
	queryKey: groupSetKeys.list(),
	queryFn: async (): Promise<RehabDecisionTreeApi[]> => {
		const { data } = await rehabApi.get<{ data: RehabDecisionTreeApi[] }>(
			'/rehabTrees?listAllAndTrees=true&treeType=AGSet',
		);
		return data.data ?? [];
	},
});
